(() => {
  if (window.__BH_POPCONVERT_STICKY_GUARD_V4__) return;
  window.__BH_POPCONVERT_STICKY_GUARD_V4__ = true;

  const MOBILE_QUERY = '(max-width: 749px)';
  const STICKY_SELECTOR = 'sticky-add-to-cart [ref="stickyBar"]';
  const ACTIVE_ATTR = 'data-bh-sticky-atc-active';
  const HIDDEN_ATTR = 'data-bh-popconvert-hidden';
  const STYLE_ID = 'bh-popconvert-sticky-guard-v4-style';
  const DIRECT_SELECTOR = [
    '#__pc_app',
    '[id^="__pc_"]',
    '[id*="popconvert" i]',
    '[class*="popconvert" i]',
    '[id*="pop-convert" i]',
    '[class*="pop-convert" i]',
    'iframe[src*="popconvert" i]',
    'iframe[src*="pop-convert" i]',
    'iframe[title*="recent purchase" i]',
    'iframe[title*="social proof" i]',
    'iframe[title*="purchase notification" i]'
  ].join(',');

  const media = window.matchMedia(MOBILE_QUERY);
  const hiddenElements = new Set();
  let stickyBar = null;
  let stickyObserver = null;
  let notificationObserver = null;
  let stickySearchObserver = null;
  let active = false;
  let scheduled = false;

  const ensureStyle = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media screen and (max-width: 749px) {
        html[${ACTIVE_ATTR}="true"] #__pc_app,
        html[${ACTIVE_ATTR}="true"] [id^="__pc_"],
        html[${ACTIVE_ATTR}="true"] [id*="popconvert" i],
        html[${ACTIVE_ATTR}="true"] [class*="popconvert" i],
        html[${ACTIVE_ATTR}="true"] [id*="pop-convert" i],
        html[${ACTIVE_ATTR}="true"] [class*="pop-convert" i],
        html[${ACTIVE_ATTR}="true"] iframe[src*="popconvert" i],
        html[${ACTIVE_ATTR}="true"] iframe[src*="pop-convert" i],
        html[${ACTIVE_ATTR}="true"] iframe[title*="recent purchase" i],
        html[${ACTIVE_ATTR}="true"] iframe[title*="social proof" i],
        html[${ACTIVE_ATTR}="true"] iframe[title*="purchase notification" i],
        [${HIDDEN_ATTR}="true"] {
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const parentAcrossShadow = (element) => {
    if (element.parentElement) return element.parentElement;
    const root = element.getRootNode?.();
    return root instanceof ShadowRoot ? root.host : null;
  };

  const isStickyActive = () => {
    if (!media.matches || !(stickyBar instanceof HTMLElement)) return false;
    if (stickyBar.dataset.stuck !== 'true') return false;

    const rect = stickyBar.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    const style = getComputedStyle(stickyBar);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
  };

  const descriptor = (element) => {
    const className = typeof element.className === 'string' ? element.className : '';
    const src = element instanceof HTMLIFrameElement ? element.src : '';

    return [
      element.id,
      className,
      element.getAttribute('data-testid') || '',
      element.getAttribute('aria-label') || '',
      element.getAttribute('title') || '',
      src
    ]
      .join(' ')
      .toLowerCase();
  };

  const hasPopConvertSignal = (element) => {
    if (!(element instanceof HTMLElement)) return false;

    if (
      /(__pc|pop[\s_-]?convert|social[\s_-]?proof|recent[\s_-]?purchase|purchase[\s_-]?notification)/i.test(
        descriptor(element)
      )
    ) {
      return true;
    }

    const text = (element.innerText || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text || text.length > 700) return false;

    return (
      text.includes('purchased ') ||
      text.includes('bought ') ||
      text.includes('added to cart') ||
      text.includes('recent purchase') ||
      (text.includes(' ago') && (text.includes('purchased') || text.includes('bought')))
    );
  };

  const rectsOverlap = (a, b, margin = 0) =>
    a.left < b.right + margin &&
    a.right > b.left - margin &&
    a.top < b.bottom + margin &&
    a.bottom > b.top - margin;

  const isCompactNotification = (element, stickyRect) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element === document.body || element === document.documentElement) return false;
    if (element === stickyBar || element.contains(stickyBar) || stickyBar?.contains(element)) return false;
    if (
      element.closest(
        'sticky-add-to-cart, #cart-drawer, cart-drawer, theme-drawer, shopify-chat, quick-add-modal, search-modal'
      )
    ) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    if (!rectsOverlap(rect, stickyRect, 28)) return false;
    if (rect.width < Math.min(210, window.innerWidth * 0.34) || rect.width > window.innerWidth * 1.05) return false;
    if (rect.height < 28 || rect.height > Math.min(360, window.innerHeight * 0.42)) return false;

    const style = getComputedStyle(element);
    return ['fixed', 'absolute', 'sticky'].includes(style.position) || element instanceof HTMLIFrameElement;
  };

  const notificationContainerFrom = (start) => {
    if (!(stickyBar instanceof HTMLElement) || !(start instanceof HTMLElement)) return null;

    const stickyRect = stickyBar.getBoundingClientRect();
    let element = start;
    let best = null;
    let signaled = false;

    for (let depth = 0; element instanceof HTMLElement && depth < 14; depth += 1) {
      signaled = signaled || hasPopConvertSignal(element);
      if (isCompactNotification(element, stickyRect)) best = element;
      element = parentAcrossShadow(element);
    }

    return signaled ? best : null;
  };

  const hideElement = (element) => {
    if (!(element instanceof HTMLElement) || hiddenElements.has(element)) return;
    element.setAttribute(HIDDEN_ATTR, 'true');
    hiddenElements.add(element);
  };

  const restoreAll = () => {
    for (const element of hiddenElements) {
      if (element.isConnected) element.removeAttribute(HIDDEN_ATTR);
    }
    hiddenElements.clear();
  };

  const inspectElement = (element) => {
    if (!(element instanceof HTMLElement) || !active) return;

    if (element.matches(DIRECT_SELECTOR)) hideElement(element);

    const container = notificationContainerFrom(element);
    if (container) hideElement(container);

    if (element.shadowRoot) inspectRoot(element.shadowRoot);
  };

  const inspectRoot = (root) => {
    if (!root || typeof root.querySelectorAll !== 'function' || !active) return;

    for (const element of root.querySelectorAll(DIRECT_SELECTOR)) {
      if (element instanceof HTMLElement) hideElement(element);
    }

    const candidates = root.querySelectorAll('iframe, aside, section, div');
    const limit = Math.min(candidates.length, 250);
    for (let index = 0; index < limit; index += 1) {
      const element = candidates[index];
      if (!(element instanceof HTMLElement)) continue;
      if (hasPopConvertSignal(element)) inspectElement(element);
      if (element.shadowRoot) inspectRoot(element.shadowRoot);
    }
  };

  const elementsAtPointDeep = (root, x, y, output) => {
    if (!root || typeof root.elementsFromPoint !== 'function') return;

    for (const element of root.elementsFromPoint(x, y)) {
      if (!(element instanceof HTMLElement) || output.has(element)) continue;
      output.add(element);
      if (element.shadowRoot) elementsAtPointDeep(element.shadowRoot, x, y, output);
    }
  };

  const scanCurrentNotification = () => {
    if (!active || !(stickyBar instanceof HTMLElement)) return;

    inspectRoot(document);

    const stickyRect = stickyBar.getBoundingClientRect();
    const elements = new Set();
    const xs = [0.08, 0.28, 0.5, 0.72, 0.92].map((ratio) => window.innerWidth * ratio);
    const ys = [
      Math.max(1, stickyRect.top - 125),
      Math.max(1, stickyRect.top - 60),
      Math.max(1, stickyRect.top + 6),
      Math.min(window.innerHeight - 1, stickyRect.top + stickyRect.height * 0.5),
      Math.min(window.innerHeight - 1, stickyRect.bottom - 4)
    ];

    for (const x of xs) {
      for (const y of ys) elementsAtPointDeep(document, x, y, elements);
    }

    for (const element of elements) inspectElement(element);
  };

  const startNotificationObserver = () => {
    notificationObserver?.disconnect();
    if (!document.body) return;

    notificationObserver = new MutationObserver((mutations) => {
      if (!active) return;

      for (const mutation of mutations) {
        if (mutation.type === 'attributes') {
          inspectElement(mutation.target);
          continue;
        }

        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          inspectElement(node);
          inspectRoot(node);
        }
      }
    });

    notificationObserver.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
  };

  const applyState = () => {
    scheduled = false;
    const nextActive = isStickyActive();
    document.documentElement.setAttribute('data-bh-pop-guard-version', '4');

    if (nextActive === active) {
      if (active) scanCurrentNotification();
      return;
    }

    active = nextActive;
    document.documentElement.setAttribute(ACTIVE_ATTR, active ? 'true' : 'false');

    if (active) {
      startNotificationObserver();
      scanCurrentNotification();
    } else {
      notificationObserver?.disconnect();
      restoreAll();
    }
  };

  const scheduleState = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(applyState);
  };

  const bindStickyBar = () => {
    const nextSticky = document.querySelector(STICKY_SELECTOR);
    if (!(nextSticky instanceof HTMLElement)) return false;
    if (stickyBar === nextSticky && stickyObserver) return true;

    stickyObserver?.disconnect();
    stickyBar = nextSticky;
    stickyObserver = new MutationObserver(() => {
      const currentSticky = document.querySelector(STICKY_SELECTOR);
      if (currentSticky !== stickyBar) bindStickyBar();
      scheduleState();
    });
    stickyObserver.observe(nextSticky.closest('sticky-add-to-cart') || nextSticky, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-stuck']
    });

    stickySearchObserver?.disconnect();
    stickySearchObserver = null;
    scheduleState();
    return true;
  };

  const findStickyBar = () => {
    if (bindStickyBar()) return;

    const scope = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
    if (!scope) return;

    stickySearchObserver?.disconnect();
    stickySearchObserver = new MutationObserver(() => {
      if (bindStickyBar()) stickySearchObserver?.disconnect();
    });
    stickySearchObserver.observe(scope, { subtree: true, childList: true });
  };

  const start = () => {
    ensureStyle();
    findStickyBar();
    media.addEventListener?.('change', scheduleState);
    window.addEventListener('pageshow', scheduleState);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
